import { SortDirection } from '../../../shared/components/ResponsiveTable/models';
import { ProductUsersQueryResult } from '../../../shared/models/ProductUsersModel';
import { ProductReportResult } from '../../../shared/models/ReportModel';
import emptySliceApi from '../../../shared/store/emptyApiSlice';

interface ReportApiRequest {
  accountId: string;
  dealId: string;
  sku: string;
  page?: number;
  pageSize?: number;
  status?: string[];
  sortProperty?: string;
  sortDirection?: SortDirection;
  StartDate?: string;
  EndDate?: string;
  searchInput?: string;
  bundleItemSkus?: string[];
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductUsers: builder.query<ProductUsersQueryResult, ReportApiRequest>({
      query: ({
        accountId,
        dealId,
        sku,
        page,
        pageSize,
        status,
        sortProperty,
        sortDirection,
        StartDate,
        EndDate,
        searchInput,
        bundleItemSkus,
      }) => {
        const bundleQuery =
          bundleItemSkus && bundleItemSkus.length > 0
            ? `&${bundleItemSkus
                .map((s) => `bundleItemSkus=${encodeURIComponent(s)}`)
                .join('&')}`
            : '';
        const statusParam =
          status && status.length > 0
            ? `&${status.map((s) => `status=${s}`).join('&')}`
            : '';
        return `accounts/${accountId}/deals/${dealId}/reports/products/${sku}/users?page=${page}&pageSize=${pageSize}&sortProperty=${sortProperty}&sortDirection=${
          sortDirection === 'Asc' ? '+' : '-'
        }${statusParam}&StartDate=${encodeURIComponent(
          StartDate,
        )}&EndDate=${encodeURIComponent(
          EndDate,
        )}&search=${searchInput}${bundleQuery}`;
      },
    }),
    getProductDetails: builder.query<ProductReportResult, ReportApiRequest>({
      query: ({ accountId, dealId, sku, StartDate, EndDate }) =>
        `accounts/${accountId}/deals/${dealId}/reports/products/${sku}?StartDate=${encodeURIComponent(
          StartDate,
        )}&EndDate=${encodeURIComponent(EndDate)}`,
    }),
  }),
});

export const { useGetProductUsersQuery, useGetProductDetailsQuery } = apiSlice;
